//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NewsListingItem from '../vue/NewsListingItem.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			show: false,
			currentFilter: 'all',
			visible: true,
			pageNumber: 0, // default to page 0
			paginatedStuff: this.pagination(),
			number_of_posts: this.number_posts_per_page(),
		};
	},

	props: {
		size: {
			default: 'one',
		},
		posts: {},
		categories: {},
		show_title: {},
		title: {
			type: String,
			default: 'BPB Auto - here to keep you driving',
		},
		show_filter: {},
		show_pagination: {},
		data_size: {
			type: Number,
			required: false,
			default: 10,
		},
		posts_per_page: {
			required: true,
		},
	},

	computed: {
		pageCount() {
			let l = this.filteredCategory.length,
				s = this.number_of_posts;
			return Math.ceil(l / s);
		},

		paginatedData() {
			const start = this.pageNumber * this.number_of_posts,
				end = start + this.number_of_posts;
			return this.filteredCategory.slice(start, end);
		},

		filteredCategory() {
			var vm = this;
			var category = vm.currentFilter;

			if (category === 'all') {
				return vm.paginatedStuff;
			} else {
				return vm.paginatedStuff.filter(function (article) {
					return article.category === category;
				});
			}
		},
	},

	watch: {},

	methods: {
		nextPage() {
			this.pageNumber++;
		},
		prevPage() {
			this.pageNumber--;
		},

		pagination() {
			let parsed = JSON.parse(this.posts);
			return parsed;
		},

		number_posts_per_page() {
			let the_result = JSON.parse(this.posts_per_page);
			return the_result.number;
		},
	},

	components: {
		NewsListingItem,
	},

	created() {
		this.currentFilter = 'all';
	},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/NewsListing.vue